import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../../lib/i18n";

export const ViewAll = ({ to, testid, label }) => {
  const { t } = useI18n();
  return <Link to={to} data-testid={testid} className="group inline-flex items-center gap-2 text-sm text-cta">{label || t("home.viewAll")}<ArrowRight className="rtl-flip h-4 w-4 transition-transform group-hover:translate-x-1" /></Link>;
};

export const useNum = () => {
  const { lang } = useI18n();
  return (n) => new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en-US").format(n);
};

export function Counter({ to, testid }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const reduce = useReducedMotion();
  const [n, setN] = useState(0);
  const fmt = useNum();
  useEffect(() => {
    if (!inView) return undefined;
    if (reduce) { setN(to); return undefined; }
    const c = animate(0, to, { duration: 1.6, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView, to, reduce]);
  return <span ref={ref} data-testid={testid} data-value={to}>{fmt(n)}</span>;
}

export const Rail = ({ children, testid, className = "" }) => (
  <div data-testid={testid} className={`no-scrollbar -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 sm:-mx-8 sm:px-8 md:mx-0 md:grid md:overflow-visible md:px-0 md:pb-0 ${className}`}>{children}</div>
);
